import Blue from "~/core";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

new Blue({
  name: "Testimonial Carousel",
  selector: ".testimonial:not([class*=featured])",
  setup(container) {
    const carousel = container.querySelector(".testimonial__inner");
    const wrapper = container.querySelector(".testimonial__wrapper");
    const slides = [...container.querySelectorAll(".testimonial__slide")];
    const prevEl = container.querySelector(
      "button.testimonial__navigation-prev"
    );
    const nextEl = container.querySelector(
      "button.testimonial__navigation-next"
    );
    const navigation = container.querySelector(".testimonial__navigation");
    const pagination = container.querySelector(".testimonial__pagination");
    const random = Math.ceil(Math.random() * 10000);
    carousel.classList.add("swiper");
    carousel.classList.add("swiper-" + random);
    carousel.style.width = "calc(100% + 2px)"; // Add width buffer
    carousel.style.paddingRight = "1px"; // Add padding for border
    carousel.style.paddingLeft = "1px"; // Add padding for border
    wrapper.classList.add("swiper-wrapper");
    slides.forEach(slide => slide.classList.add("swiper-slide"));
    pagination.classList.add("swiper-pagination");
    pagination.classList.add("swiper-pagination-" + random);
    let lessThanTwoSlides = slides.length < 2;

    const swiper = new Swiper(".swiper-" + random, {
      loop: !lessThanTwoSlides,
      slidesPerView: 1,
      spaceBetween: 22,
      navigation: {
        prevEl: ".testimonial__navigation-prev",
        nextEl: ".testimonial__navigation-next"
      },
      pagination: {
        el: pagination,
        type: "bullets",
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: lessThanTwoSlides ? 1 : 2,
          spaceBetween: 22
        }
      }
    });

    if (lessThanTwoSlides) {
      pagination.remove();
    }
  }
});
